/**
 * Avatar preset gallery.
 *
 * Users pick from a fixed set of preset avatars; only the short key is stored
 * in the DB (users.avatar VARCHAR(32)). Visual rendering (icon + gradient)
 * lives in the web package — this module is the single source of truth for the
 * valid keys, shared by server (validation) and web (picker + rendering).
 */
export const AVATAR_PRESET_IDS = [
  'crown',
  'star',
  'flame',
  'zap',
  'shield',
  'rocket',
  'gem',
  'leaf',
  'moon',
  'sun',
  'heart',
  'ghost',
] as const;

export type AvatarId = (typeof AVATAR_PRESET_IDS)[number];

/**
 * Returns true if the given value is a valid avatar preset key.
 */
export function isAvatarId(value: unknown): value is AvatarId {
  return typeof value === 'string' && (AVATAR_PRESET_IDS as readonly string[]).includes(value);
}
